import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { TeacherStatsService } from '@edtech-ui/core/services/admin-panel/teacher-stats.service';
import { TableModule } from 'primeng/table';
import { AdminService } from '@edtech-ui/core/services/admin-dashboard/admin.service';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { TeacherAnalyticsStatisticData } from '@edtech-ui/core/models/admin-panel/admin-analytics';
import { ToastrService } from 'ngx-toastr';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
	selector: 'app-teacher-stats',
	standalone: true,
	imports: [
		CommonModule,
		MatTabsModule,
		MatIconModule,
		MatButtonModule,
		MatBadgeModule,
		MatProgressSpinnerModule,
		TableModule,AdminHeaderComponent
	],
	templateUrl: './teacher-stats.component.html',
	styleUrl: './teacher-stats.component.scss'
})
export class TeacherStatsComponent implements OnInit, OnDestroy {

	teachersData: TeacherAnalyticsStatisticData[] = [];
	subscription = new Subscription();
	teacherCount: number = 0;
	teachers: any[] = [];
	isloading = false;
	tenantName='Analytics & Reports';
	tenantSubName='View insights and performance metrics';

	constructor(
		private _adminService: AdminService,
		private _toastr: ToastrService
	) { }

	ngOnInit() {
		this.getAllTeacherStatistics();
	}

	getAllTeacherStatistics() {
		this.isloading = true;
		this.subscription.add(
			this._adminService.getAllStatisticsTeachers().pipe(
				tap(response => {
					if (response.Success) {
						this.teachersData = response.Data.teachers;
						this.teacherCount = response.Data.total_teachers;
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isloading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went Wrong while fetching the Teachers Data');
					return of(null);
				})
			).subscribe()
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}